import { HttpStatusCode } from "axios";
import DepartmentResourceService from "../../apiServices/masters/departmentResourceService";
import { alertConstants } from "../../helper/sweet-alert";
import {
  setDepartmentResource,
  setDepartmentResources,
} from "../../store/slices/master/departmentResource";

export function getDepartmentResource(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentResourceService.getDepartmentResource(id);
    if (response?.success === true) {
      dispatch(setDepartmentResource(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getDepartmentResources(
  pageBlockId?: number,
  noOfItems?: number,
  configUserType?: number
) {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentResourceService.getDepartmentResources(
      pageBlockId,
      noOfItems,
      configUserType
    );
    if (response?.success === true) {
      dispatch(setDepartmentResources(response.data));
    } else {
      console.log("error");
    }
  };
}

export function createDepartmentResource(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentResourceService.createDepartmentResource(data);
    const name = data.get("name")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateDepartmentResource(
  data: any,
  id: number,
  callback: Function
) {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentResourceService.updateDepartmentResource(
      data,
      id
    );
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateDepartmentResourcePriority(
  data: any,
  callback: Function
) {
  return async function (dispatch: any, getState: any) {
    let response =
      await DepartmentResourceService.updateDepartmentResourcePriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function deleteDepartmentResource(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentResourceService.deleteDepartmentResource(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
